export default ":host ::ng-deep .chips {\n  width: 350px;\n}\n:host ::ng-deep .mat-icon-button .mat-icon {\n  font-size: 20px;\n}";